export const DRAWER_WIDTH = 300;
export const APPBAR_HEIGHT_MOBILE = 64;
